/**
* Timeline JS
* -----------------------------------------------------------------------------
*
* All the JS for the Timeline component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin.js';
gsap.registerPlugin( ScrollTrigger, DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'timeline',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.draw-svg' ).length ) {
        let top = $( '.navbar' ).outerHeight() + 400;
        if ( $( '.logged-in' ).length ) {
          top += 32;
        }
        $( '.draw-svg' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: $( this ),
              scrub: 1,
              start: `top top+=${top}`,
              end: 'bottom top',
            },
          } );
          tl.from( $( this ), {duration: 1, drawSVG: 0} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'timeline', COMPONENT );
} )( app );
